import React from 'react';
import PropTypes from 'prop-types';

import {LLBtn, withCommon} from '../../../components';

/**
 * @file Represents React Component to render buttons that open modals
 * @memberOf PromoCards
 *
 * @param {number} id - id of selected bonus
 * @param {func} openModal - open modal function / params { id, type }: id - selected bonus id, type - type of modal
 *
 * @author I.Mykhailychenko
 */

const PromoButtons = withCommon({
    store: ({ store }) => ({
        openModal: store.promos.openModal,
        viewSize: store.site.status.viewSize,
        mobileUserAgent: store.user.mobileUserAgent,
        userCanHaveBonus: store.user.canHaveBonus,
        user: store.user,
        openPersonalInfoForm: store.user.openPersonalInfoForm,
        openChat: store.liveChat.open,
    }),
    propTypes: {
        id: PropTypes.number.isRequired,
        rules: PropTypes.string,
        openModal: PropTypes.func.isRequired,
    },
    defaultProps: {
        rules: null,
    },
    defaultName: 'PromoButtons',
    isObserver: true,
    isTrans: true,
})(({ trans, id, rules, isRequestEnabled, openModal, viewSize, userCanHaveBonus, user, openPersonalInfoForm, openChat }) => {
    const handleRulesModal = () => {
        openModal(id, 'rules');
    };

    const handleDescrModal = () => {
        if (!user.openMembershipGate('bonus')) {
            return;
        }
        openModal(id, 'descr');
    };

    const bonusGate = user.membershipGateKind('bonus');

    return (
        <div className="promo-content__btn-wrp">
            {isRequestEnabled && userCanHaveBonus && bonusGate === 'prompt' ? (
                <LLBtn
                    customClasses={`promo-content__btn ll-btn--square--${viewSize}`}
                    onClick={openPersonalInfoForm}
                >
                    {trans('Enter My Information')}
                </LLBtn>
            ) : null}

            {isRequestEnabled && userCanHaveBonus && bonusGate === 'blocked' ? (
                <LLBtn
                    customClasses={`promo-content__btn ll-btn--square--${viewSize}`}
                    onClick={openChat}
                >
                    {trans('CONTACT LIVE SUPPORT')}
                </LLBtn>
            ) : null}

            {isRequestEnabled && userCanHaveBonus && !bonusGate ? (
                <LLBtn
                    customClasses={`promo-content__btn ll-btn--square--${viewSize}`}
                    onClick={handleDescrModal}
                >
                    {trans('Get Bonus')}
                </LLBtn>
            ) : null}

            {rules || !isRequestEnabled ? (
                <LLBtn
                    customClasses={`promo-content__btn ll-btn--square-outlined--${viewSize}`}
                    onClick={() => rules && handleRulesModal()}
                >
                    {rules && trans('Bonus Rules')}
                </LLBtn>
            ) : null}
        </div>
    );
});

export default PromoButtons;
